<div class="container-password">
  <div class="small-padding">
    <form [formGroup]="changePasswordForm" class="align-center">
      <div *ngIf="checkStrongPassword" class="k-text-left">
        <ul>
          <p>
            <kendo-svg-icon 
            [icon]="!haveMoreThen6 ? icon.xIcon : icon.checkIcon" 
            [themeColor]="!haveMoreThen6 ? 'error' : 'success'"
            ></kendo-svg-icon> Longueur
            minimale (6 ou plus?)
          </p>
          <p>
            <kendo-svg-icon 
            [icon]="!haveNumber ? icon.xIcon : icon.checkIcon"
            [themeColor]="!haveNumber ? 'error' : 'success'"
            ></kendo-svg-icon> Un numéro
            requis
          </p>
          <p>
            <kendo-svg-icon 
            [icon]="!haveUpperCase ? icon.xIcon : icon.checkIcon"
            [themeColor]="!haveUpperCase ? 'error' : 'success'"
            ></kendo-svg-icon> Caractères
            en majuscules requis
          </p>
          <p>
            <kendo-svg-icon 
            [icon]="!checkSpecial ? icon.xIcon : icon.checkIcon"
            [themeColor]="!checkSpecial ? 'error' : 'success'"
            ></kendo-svg-icon> Caractères
            spéciaux requis ($,%, &, #, etc.)
          </p>
        </ul>
      </div>
      <br />
      <div class="small-margin">
        <input
          kendoTextBox
          class="full-size"
          type="password"
          formControlName="password1"
          #passwordChecker
          [placeholder]="'Nouveau mot de passe'"
        />
      </div>
      <div class="small-margin">
        <input
          type="password"
          kendoTextBox
          class="full-size"
          formControlName="password2"
          [placeholder]="'Confirmer le mot de passe'"
        />
      </div>
      <br />
      <div *ngIf="notSamePassword" class="alert-color">
        Les mots de passe ne correspondent pas.
      </div>

      <div class="login-button">
        <button
          *ngIf="!changePasswordForm.controls['password2'].disabled"
          (click)="changePassword()"
          class="colored-text full-size button-valide"
          kendoButton
          class="primary-background"
        >
          <ng-container *ngIf="!submited; else loading" class="k-text-uppercase primary-color button-valide">
            VALIDER
          </ng-container>
          <ng-template #loading>
            CHARGEMENT...
          </ng-template>
        </button>
      </div>
    </form>
  </div>
</div>
